// CMSH-996 TOTP 도입 — 신규 endpoint 클라이언트.
// 기존 Service/Login/Login.js 패턴 (fetch + JSON) 동일.

/**
 * 등록 화면 진입 — pending_token (step=E1) → QR + next_token (step=E2) 받기.
 */
export async function lfnEnrollTotp(pendingToken) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ pending_token: pendingToken })
    };
    try {
        const response = await fetch('/Logon/EnrollTotp', requestOptions);
        return await response.json();
    } catch (err) {
        return { err: -1, result: 'F_ERROR', errMsg: String(err) };
    }
}

/**
 * 등록 확정 — next_token (step=E2) + 사용자 입력 6자리 → 영구 등록 + 백업코드 + guid.
 */
export async function lfnConfirmTotpEnrollment(nextToken, code) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ pending_token: nextToken, code: code })
    };
    try {
        const response = await fetch('/Logon/ConfirmTotpEnrollment', requestOptions);
        return await response.json();
    } catch (err) {
        return { err: -1, result: 'F_ERROR', errMsg: String(err) };
    }
}

/**
 * 일상 검증 — pending_token (step=V1) + 6자리 → guid + sUrl 매핑.
 */
export async function lfnVerifyTotp(pendingToken, code) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ pending_token: pendingToken, code: code })
    };
    try {
        const response = await fetch('/Logon/VerifyTotp', requestOptions);
        return await response.json();
    } catch (err) {
        return { err: -1, result: 'F_ERROR', errMsg: String(err) };
    }
}

/**
 * 그레이스 기간 중 등록 스킵 — next_token (EnrollConfirm) consume 후 정상 세션 발급.
 */
export async function lfnSkipTotpEnrollment(nextToken) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ pending_token: nextToken })
    };
    try {
        const response = await fetch('/Logon/SkipTotpEnrollment', requestOptions);
        return await response.json();
    } catch (err) {
        return { err: -1, result: 'F_ERROR', errMsg: String(err) };
    }
}

/**
 * 백업 코드 사용 — pending_token (step=V1) + 8자리 영숫자 → guid.
 */
export async function lfnUseRecoveryCode(pendingToken, recoveryCode) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ pending_token: pendingToken, recovery_code: recoveryCode })
    };
    try {
        const response = await fetch('/Logon/UseRecoveryCode', requestOptions);
        return await response.json();
    } catch (err) {
        return { err: -1, result: 'F_ERROR', errMsg: String(err) };
    }
}

/**
 * 성공 응답의 data ({col_1=sys_gbn, col_2=url}) 를 사용해 정상 리다이렉트.
 * 기존 Login.js 의 패턴 재사용.
 */
export function lfnRedirectAfterSuccess(responseData, sysGbn) {
    if (!responseData || responseData.err !== 0) return false;
    if (!responseData.data || !responseData.data.length) {
        // sUrl 매핑이 없으면 홈으로
        window.location.href = '/';
        return true;
    }
    const match = responseData.data.filter(e => e.col_1 === sysGbn);
    if (match.length > 0) {
        const sUrl = match[0].col_2;
        const guid = responseData.guid || '';
        let guidEl = document.getElementById('guid');
        let frm = document.getElementById('frmLogin1');
        if (!frm) {
            // frmLogin1 이 없을 수 있어 임시 생성
            frm = document.createElement('form');
            frm.id = 'frmLogin1';
            frm.method = 'post';
            guidEl = document.createElement('input');
            guidEl.type = 'hidden';
            guidEl.name = 'guid';
            guidEl.id = 'guid';
            frm.appendChild(guidEl);
            document.body.appendChild(frm);
        }
        guidEl.value = guid;
        frm.setAttribute('action', sUrl);
        frm.submit();
        return true;
    }
    return false;
}
